// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CloseButton_wrapper__sct_O"};